import * as React from 'react';
import { Link } from 'react-router-dom';
import { Col, Media, Row } from 'react-bootstrap';
import { Translate } from '../../../../../../shared/LanguageService';
import InlineTooltip from '../../../../../../components/common/ToolTip';

type PlanProductsProps = {
    existingOrderData: any;
    products: any;
    onClickProduct: (id: number) => void;
};

export function PlanProducts({ existingOrderData, products, onClickProduct }: PlanProductsProps) {
    return (
        <Row>
            <div className="rowlabel">
                {Translate('orders/create/panel-headings/row-label-floorplans')}
            </div>
            {(!existingOrderData ||
                ( existingOrderData && (!existingOrderData.existingPlanOrderId || existingOrderData.allowPlanOrder) )
                ) &&
                products.map((x: any, index: number) => (
                    <Col key={x.id + '-' + index} xs={12} sm={6} md={4} lg={3}>
                        <Media
                            data-testid={`plan-product-${x.id}`}
                            className={
                                'product-box ' +
                                (x.available ? 'floorplan ' : 'disabled ') +
                                (x.selected ? 'selected ' : ' ') +
                                (x.required ? 'required ' : ' ')
                            }
                            onClick={() => onClickProduct(x.id)}
                        >
                            <Media.Left align="middle">
                                <i className="material-icons">map</i>
                            </Media.Left>
                            <Media.Body>
                                <Col sm={8}>
                                    <h5>{x.name} </h5>
                                </Col>
                                {x.priceBrokerFirm !== null ? (
                                    <Col sm={4} className="price-broker-firm">
                                        <p>
                                            {x.priceBrokerFirm.value}
                                            {x.currencySign}
                                        </p>
                                    </Col>
                                ) : (
                                    ''
                                )}
                            </Media.Body>
                            <Media.Right align="middle">
                                <InlineTooltip id={x.id} tooltip={x.extraText} />
                            </Media.Right>
                        </Media>
                    </Col>
                ))}
            {existingOrderData && !existingOrderData.allowPlanOrder && existingOrderData.existingPlanOrderId &&  (
                <Col sm={12}>
                    <Link
                        className="existing-plan-order-link"
                        target="_blank"
                        to={`/orders/${existingOrderData.existingPlanOrderId}`}
                    >
                        {Translate('orders/create/plan-order-exists')}
                    </Link>
                </Col>
            )}
        </Row>
    );
}
